import { render, staticRenderFns } from "./ImportAnggaran.vue?vue&type=template&id=c973b85e&"
import script from "./ImportAnggaran.vue?vue&type=script&lang=js&"
export * from "./ImportAnggaran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports